import { useState, useCallback } from 'react'

export const useChipInputHandlers = ({ onAddChip }) => {
  const [inputValue, setInputValue] = useState('')

  const handleInputChange = useCallback(({ target }) => {
    setInputValue(target.value)
  }, [])

  const handleEnterKey = useCallback(
    ({ target }) => {
      onAddChip(target.value)
      setInputValue('')
    },
    [onAddChip]
  )

  const clearInput = useCallback(() => {
    setInputValue('')
  }, [])

  return {
    inputValue,
    handleInputChange,
    handleEnterKey,
    clearInput,
  }
}
